/**
 * Constants and default values for ResourceDetailModal
 */

export const INITIAL_FORM_DATA = {
  name: '',
  description: '',
  type: 'bot',
  tenant_id: '',
  cost_pool_id: '',
  configuration: {}
};

export const INITIAL_LOADING_REFS = {
  tenants: false,
  costPools: false,
  products: false,
  prices: false
};

export const RESOURCE_TYPES = {
  BOT: 'bot',
  RESALE: 'resale'
};

export const MODES = {
  VIEW: 'view',
  CREATE: 'create',
  EDIT: 'edit'
};

export const DEFAULT_RESOURCE_TYPE = 'bot';


